import { Directive, HostListener, Component, Inject } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Directive({
  selector: '[appLinkShareHandler]',
})
export class LinkShareHandlerDirective {
  constructor(private bottomSheet: MatBottomSheet) {}

  @HostListener('click', ['$event'])
  onMouseEnter(event: any) {
    event.preventDefault();
    if (event.target.href) {
      this.openBottomSheet(event.target.href);
    }
  }

  openBottomSheet(url: string): void {
    this.bottomSheet.open(LinkShareHandlerComponent, {
      data: { href: url },
    });
  }
}

@Component({
  selector: 'app-link-share-handler-component',
  templateUrl: 'link-share-handler-component.html',
})
export class LinkShareHandlerComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<LinkShareHandlerComponent>
  ) {}

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
